import { SvgIconProps } from '@mui/material'
import SvgIcon from '@mui/material/SvgIcon'
import { IconActive } from 'components/ArteelIcons/IconActive'

export const Minus = ({ active, ...rest }: SvgIconProps & IconActive) => (
  <SvgIcon {...rest} viewBox="0 0 70 70">
    <path d="m66.38,32.9l-61.88,0c-1.4,0 -2.54,1.14 -2.54,2.54c0,1.4 1.14,2.54 2.54,2.54l61.87,0c0.01,0 0.01,0 0.01,0c1.4,0 2.53,-1.13 2.54,-2.53c-0.02,-1.41 -1.15,-2.54 -2.54,-2.55z" />
  </SvgIcon>
)
